if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          if (target && typeof target.addPreProcessCallback === 'function') {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          }
        });
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification && this.openedBy) {
          cartNotification.setActiveElement(this.openedBy);
        }

        if (this.modalContent) {
          this.modalContent.innerHTML = '';
        }

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {
        if (!opener) return;

        const spinner = opener.querySelector('.loading__spinner');

        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const productUrl = opener.getAttribute('data-product-url');

        if (!productUrl || !this.modalContent) {
          this.finishLoading(opener);
          return;
        }

        fetch(productUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Quick Add request failed: ${response.status}`
              );
            }

            return response.text();
          })
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );

            const productElement =
              responseHTML.querySelector('product-info');

            if (!productElement) {
              throw new Error(
                'Product information could not be loaded.'
              );
            }

            this.preprocessHTML(productElement);

            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            super.show(opener);
          })
          .catch((error) => {
            console.error('Quick Add:', error);
          })
          .finally(() => {
            this.finishLoading(opener);
          });
      }

      finishLoading(opener) {
        if (!opener) return;

        const spinner = opener.querySelector('.loading__spinner');

        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');

        if (spinner) {
          spinner.classList.add('hidden');
        }
      }

      preprocessHTML(productElement) {
        if (!productElement) return;

        productElement.classList.forEach((classApplied) => {
          if (
            classApplied.startsWith('color-') ||
            classApplied === 'gradient'
          ) {
            if (this.modalContent) {
              this.modalContent.classList.add(classApplied);
            }
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute(
          'data-update-url',
          'false'
        );
      }

      removeDOMElements(productElement) {
        const pickupAvailability =
          productElement.querySelector(
            'pickup-availability'
          );

        if (pickupAvailability) {
          pickupAvailability.remove();
        }

        const productModal =
          productElement.querySelector('product-modal');

        if (productModal) {
          productModal.remove();
        }

        const modalDialogs =
          productElement.querySelectorAll('modal-dialog');

        modalDialogs.forEach((modal) => {
          modal.remove();
        });
      }

      preventDuplicatedIDs(productElement) {
        const sectionId =
          productElement.dataset.section;

        if (!sectionId) return;

        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML =
          productElement.innerHTML.replaceAll(
            sectionId,
            newId
          );

        Array.from(productElement.attributes).forEach(
          (attribute) => {
            if (attribute.value.includes(sectionId)) {
              productElement.setAttribute(
                attribute.name,
                attribute.value.replaceAll(
                  sectionId,
                  newId
                )
              );
            }
          }
        );

        productElement.dataset.originalSection =
          sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList =
          productElement.querySelector(
            '[id^="Slider-Gallery"]'
          );

        if (!galleryList) return;

        galleryList.setAttribute(
          'role',
          'presentation'
        );

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => {
            li.setAttribute(
              'role',
              'presentation'
            );
          });
      }

      updateImageSizes(productElement) {
        const product =
          productElement.querySelector('.product');

        const desktopColumns =
          product?.classList.contains(
            'product--columns'
          );

        if (!desktopColumns) return;

        const mediaImages =
          product.querySelectorAll(
            '.product__media img'
          );

        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (
          product.classList.contains(
            'product--medium'
          )
        ) {
          mediaImageSizes =
            mediaImageSizes.replace(
              '715px',
              '605px'
            );
        } else if (
          product.classList.contains(
            'product--small'
          )
        ) {
          mediaImageSizes =
            mediaImageSizes.replace(
              '715px',
              '495px'
            );
        }

        mediaImages.forEach((img) => {
          img.setAttribute(
            'sizes',
            mediaImageSizes
          );
        });
      }
    }
  );
}


/* =========================================================
   CUSTOM HOVER QUICK ADD
   QUICK ADD → SIZE → ADD TO CART
   ========================================================= */

(function () {
  function initCustomQuickAdd() {
    const quickAdds =
      document.querySelectorAll(
        '.custom-quick-add'
      );

    if (!quickAdds.length) return;

    quickAdds.forEach((quickAdd) => {
      if (
        quickAdd.dataset.quickAddInitialized ===
        'true'
      ) {
        return;
      }

      const trigger =
        quickAdd.querySelector(
          '.custom-quick-add__trigger'
        );

      const variants =
        quickAdd.querySelector(
          '.custom-quick-add__variants'
        );

      if (!trigger || !variants) {
        return;
      }

      quickAdd.dataset.quickAddInitialized =
        'true';

      trigger.setAttribute(
        'aria-expanded',
        'false'
      );

      function setExpanded(expanded) {
        trigger.setAttribute(
          'aria-expanded',
          expanded ? 'true' : 'false'
        );

        if (expanded) {
          quickAdd.classList.add('is-open');
        } else {
          quickAdd.classList.remove(
            'is-open'
          );
        }
      }


      /* Desktop hover */
      trigger.addEventListener(
        'mouseenter',
        function () {
          setExpanded(true);
        }
      );

      quickAdd.addEventListener(
        'mouseenter',
        function () {
          setExpanded(true);
        }
      );


      /* Keyboard accessibility */
      trigger.addEventListener(
        'focus',
        function () {
          setExpanded(true);
        }
      );


      /* Close after leaving */
      quickAdd.addEventListener(
        'mouseleave',
        function () {
          if (
            !quickAdd.contains(
              document.activeElement
            )
          ) {
            setExpanded(false);
          }
        }
      );


      /* Keyboard focus leave */
      quickAdd.addEventListener(
        'focusout',
        function () {
          requestAnimationFrame(
            function () {
              if (
                !quickAdd.contains(
                  document.activeElement
                )
              ) {
                setExpanded(false);
              }
            }
          );
        }
      );


      /*
       * Mobile / touch
       * First tap opens sizes.
       */
      trigger.addEventListener(
        'click',
        function (event) {
          const isTouch =
            window.matchMedia &&
            window.matchMedia(
              '(hover: none)'
            ).matches;

          if (!isTouch) {
            return;
          }

          event.preventDefault();

          const expanded =
            trigger.getAttribute(
              'aria-expanded'
            ) === 'true';

          setExpanded(!expanded);
        }
      );


      /*
       * Size button
       */
      quickAdd.addEventListener(
        'click',
        function (event) {
          const sizeButton =
            event.target.closest(
              '.custom-quick-add__size'
            );

          if (
            !sizeButton ||
            sizeButton.disabled
          ) {
            return;
          }

          /*
           * Add loading state.
           * Dawn product-form handles
           * the actual AJAX cart request.
           */
          sizeButton.classList.add(
            'loading'
          );

          /*
           * Remove loading state after
           * Dawn has processed the request.
           */
          window.setTimeout(
            function () {
              sizeButton.classList.remove(
                'loading'
              );
            },
            1200
          );
        }
      );
    });
  }


  /*
   * Initial page load
   */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initCustomQuickAdd
    );
  } else {
    initCustomQuickAdd();
  }


  /*
   * Shopify can dynamically replace
   * product cards when:
   *
   * - Filters are applied
   * - Sorting changes
   * - Pagination loads
   * - Collection updates
   *
   * Re-initialize Quick Add.
   */
  const observer =
    new MutationObserver(
      function (mutations) {
        let shouldInitialize = false;

        mutations.forEach(
          function (mutation) {
            if (
              mutation.addedNodes &&
              mutation.addedNodes.length
            ) {
              shouldInitialize = true;
            }
          }
        );

        if (shouldInitialize) {
          initCustomQuickAdd();
        }
      }
    );

  if (document.body) {
    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }
})();